import React, { useState, useEffect } from "react";
import styledComp from "styled-components";
import {
  Button,
  Checkbox,
  FormControlLabel,
  OutlinedInput,
} from "@mui/material";
import { openCampaignApi, submitFormApi } from "../../../Api";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Typography, Box } from "@mui/material";
import { styled } from "@mui/system";
import InputAdornment from "@mui/material/InputAdornment";

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "fit-content",
  textAlign: "left",
  padding: theme.spacing(2),
  height: "fit-content",
  border: "2px solid #0982BA",
  borderRadius: "5px",
  backgroundColor: "white",
}));

const Header = styled(Typography)(({ theme }) => ({
  font: "normal normal 600 24px Poppins",
  textAlign: "center",
  width: "100%",
  marginBottom: theme.spacing(2),
  color: "#F47720",
  variant: "h6",
  component: "span",
  [[theme.breakpoints.between("xs", "md")]]: {
    font: "normal normal 600 16px Poppins",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 600 20px Poppins",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 600 24px Poppins",
  },
}));

const Label = styled(Typography)(({ theme }) => ({
  font: "normal normal 400 12px Poppins",
  color: "#5a6066",
  variant: "body1",
  component: "span",
  [[theme.breakpoints.between("xs", "md")]]: {
    font: "normal normal 400 10px Poppins",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 400 10px Poppins",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 400 12px Poppins",
  },
}));

const SubHeader = styled(Typography)(({ theme }) => ({
  font: "normal normal 500 12px Poppins",
  textAlign: "left",
  color: "#353535",
  variant: "caption",
  component: "span",
  [[theme.breakpoints.between("xs", "md")]]: {
    font: "normal normal 500 8px Poppins",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 500 10px Poppins",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 500 12px Poppins",
  },
}));

const Message = styled(Typography)(({ theme }) => ({
  font: "normal normal 500 18px Poppins",
  textAlign: "center",
  color: "#353535",
  vaiant: "h6",
  component: "p",
}));
const CountryCode = styled(Typography)(({ theme }) => ({
  font: "normal normal 400 14px Poppins",
  textAlign: "center",
  color: "#353535",
  vaiant: "h6",
  component: "p",
}));

const Form = styledComp.form`
  display: flex;
  flex-direction: column;
`;
const InputContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
}));

const InputWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  backgroundColor: "white",
  width: " 100%",
  marginBottom: theme.spacing(1.5),
  borderRadius: "8px",
  height: "30px",
  overflow: "hidden",
}));

const SelectWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  height: "30px",
  marginBottom: theme.spacing(1.5),
  borderRadius: "8px",
}));

const DisclaimerWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  columnGap: "10px",
  width: "100%",
  marginBottom: theme.spacing(2),
}));

const employmentTypeList = ["Salaried", "Self Employed"];

const ContactForm = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const [data, setData] = useState({
    phone: "",
    name: "",
    email: "",
    employment_type: "",
    loan_amount: "",
  });
  const [isCheckedDisclaimer, setIsCheckedDisclaimer] = useState(false);

  const [flag, setFlag] = useState(false);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (queryParams.get("cid") !== null) {
      let cid = queryParams.get("cid");
      let formData = {
        phone: `+91-${data["phone"]}`,
        email: data["email"],
        name: data["name"],
        employment_type: data["employment_type"],
        bank: "induslnd",
        loan_amount: parseInt(data["loan_amount"]),
      };
      let response = await submitFormApi({
        data: formData,
        campaign_id: cid,
      });
    }
    setData({
      phone: "",
      name: "",
      loan_amount: "",
      email: "",
      employment_type: "",
    });
    setFlag(true);
  };
  const openCampaign = async () => {
    let cid = queryParams.get("cid");
    if (cid !== null) {
      let response = await openCampaignApi(cid);
    }
  };
  useEffect(() => {
    openCampaign();
  }, []);
  return (
    <>
      {!flag ? (
        <Container>
          <Header>Digital | Instant | Simple</Header>
          <Form
            onSubmit={(e) => {
              handleSubmit();
              e.preventDefault();
            }}
          >
            <InputContainer>
              <Label>Phone*</Label>
              <InputWrapper>
                <OutlinedInput
                  autoComplete="off"
                  required
                  value={data.phone}
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "^[0-9]{10}$",
                    maxLength: 10,
                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <CountryCode>+91</CountryCode>
                    </InputAdornment>
                  }
                  name="phone"
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    font: "normal normal 400 14px Poppins",
                  }}
                />
              </InputWrapper>
              <Label>Name*</Label>
              <InputWrapper>
                <OutlinedInput
                  autoComplete="off"
                  required
                  value={data.name}
                  name="name"
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    height: "30px",
                    borderRadius: "8px",
                    font: "normal normal 400 14px Poppins",
                  }}
                />
              </InputWrapper>
              <Label>Employment Type*</Label>
              <SelectWrapper>
                <FormControl
                  sx={{
                    width: "100%",
                    height: "30px",
                    backgroundColor: "white",
                    borderRadius: "8px",
                    marginBottom: "20px",
                  }}
                >
                  <Select
                    style={{
                      width: "100%",
                      height: "30px",
                      font: "normal normal 400 14px Poppins",
                    }}
                    name="employment_type"
                    value={data.employment_type}
                    onChange={handleChange}
                    MenuProps={{
                      disableScrollLock: true,
                    }}
                    required
                    inputProps={{
                      "aria-label": "Without label",
                      style: { borderColor: "transparent" },
                    }}
                  >
                    {employmentTypeList.map((item) => {
                      return (
                        <MenuItem
                          style={{ font: "normal normal 400 14px Poppins" }}
                          value={item}
                        >
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </SelectWrapper>
              <Label>Loan Amount*</Label>
              <InputWrapper>
                <OutlinedInput
                  type="number"
                  autoComplete="off"
                  required
                  value={data.loan_amount}
                  inputProps={{
                    inputMode: "numeric",
                  }}
                  name="loan_amount"
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    font: "normal normal 400 14px Poppins",
                  }}
                />
              </InputWrapper>
              <Label>Email</Label>
              <InputWrapper>
                <OutlinedInput
                  autoComplete="off"
                  value={data.email}
                  name="email"
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    height: "30px",
                    borderRadius: "8px",
                    font: "normal normal 400 14px Poppins",
                  }}
                />
              </InputWrapper>
            </InputContainer>
            <DisclaimerWrapper>
              <FormControlLabel
                sx={{ alignItems: "start" }}
                onChange={() => {
                  setIsCheckedDisclaimer(!isCheckedDisclaimer);
                }}
                control={
                  <Checkbox
                    color="primary"
                    checked={isCheckedDisclaimer}
                    sx={{ paddingTop: "0px" }}
                  />
                }
                label={
                  <SubHeader>
                    I authorize Omfinserv and its representatives to Call, SMS
                    or communicate via WhatsApp on behalf of Banks, NBFC’s,
                    HFC’s, and Insurance companies. This consent overrides any
                    registration for DNC / NDNC. I confirm I am in India, I am a
                    major and a resident of India and I have read, and I
                    accepted Omfinserv's Privacy Policy.
                  </SubHeader>
                }
              />
            </DisclaimerWrapper>
            {/* <ButtonWrapper> */}
            <Button
              disabled={!isCheckedDisclaimer}
              variant="contained"
              color="primary"
              type="submit"
              style={{
                textTransform: "none",
                color: "white",
                font: "normal normal 700 16px open sans",
              }}
            >
              APPLY NOW
            </Button>
            {/* </ButtonWrapper> */}
          </Form>
        </Container>
      ) : (
        <Container
          style={{
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Message>
            Thank you for sharing your details! Our representative will contact
            you shortly
          </Message>
        </Container>
      )}
    </>
  );
};

export default ContactForm;
